import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import apiClient from "../../axiosInstance";
import showAlert from "../../components/Common/ShowAlert";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const Roles = () => {
  const [breadcrumbItems] = useState([
    { title: "Daryeel", link: "/" },
    { title: "Roles List", link: "#" },
  ]);

  const [data, setData] = useState([]);
  const [modalCreate, setModalCreate] = useState(false);
  const [roleName, setRoleName] = useState("");
  const [editRoleId, setEditRoleId] = useState(null);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const result = await apiClient.get("/roles/getAllRoles");
        const response = result.data.response;
        console.log(response);
        setData(response);
      } catch (err) {
        console.error("Error fetching users:", err);
      }
    };

    fetchRoles();
  }, [roleName]);

  const toggleCreateModal = () => setModalCreate(!modalCreate);

  const handleRoleNameChange = (e) => setRoleName(e.target.value);

  const handleSaveRole = async () => {
    try {
      if (editRoleId) {
        const id = editRoleId;
        const response = await apiClient.put(`/roles/updateRole/${id}`, {
          role_name: roleName,
        });
        await showAlert({
          title: "Role Update!",
          text: response.data.message,
          icon: response.data.status,
          goBack: false,
          timer: 5000,
        });
        if (response.data.status === "success") {
          setRoleName("");
          setEditRoleId(null);
          setModalCreate(false);
        }
      } else {
        const response = await apiClient.post("roles/createRole", {
          role_name: roleName,
        });
        await showAlert({
          title: "Role Creation!",
          text: response.data.message,
          icon: response.data.status,
          goBack: false,
          timer: 5000, // optional: change timer duration (ms)
        });
        if (response.data.status === "success") {
          setModalCreate(false);
          setRoleName("");
        }
      }

      // Optionally refresh roles list here
    } catch (err) {
      console.error("Error creating role:", err);
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <div className="row">
          <div className="col-12">
            <Breadcrumbs title="Roles List" breadcrumbItems={breadcrumbItems} />
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Card>
              <CardBody>
                <div className="row">
                  <div className="col-12 text-end mb-3">
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setEditRoleId(null);
                        setRoleName("");
                        toggleCreateModal();
                      }}
                    >
                      Create Role
                    </button>
                  </div>
                </div>

                {/* Roles grid */}
                <div className="row g-3">
                  {Array.isArray(data) && data.length > 0 ? (
                    data.map((role) => (
                      <div
                        className="col-12 col-sm-6 col-lg-4 col-xl-3"
                        key={role.id}
                      >
                        <Card className="h-100 shadow-sm">
                          <CardBody className="d-flex flex-column">
                            <h5 className="mb-4">{role.name}</h5>
                            <div className="mt-auto">
                              <button
                                className="btn btn-outline-primary w-100"
                                onClick={() => {
                                  setEditRoleId(role.id);
                                  setRoleName(role.name);
                                  setModalCreate(true);
                                }}
                              >
                                <i className="ri-file-edit-line me-1"></i>
                                Edit Role
                              </button>
                            </div>
                          </CardBody>
                        </Card>
                      </div>
                    ))
                  ) : (
                    <div className="col-12">
                      <div className="text-center text-muted py-5">
                        No roles found.
                      </div>
                    </div>
                  )}
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
        <Modal
          isOpen={modalCreate}
          toggle={toggleCreateModal}
          centered={true}
          backdrop="static"
        >
          <ModalHeader toggle={toggleCreateModal}>
            {editRoleId ? "Edit Role" : "Create Role"}
          </ModalHeader>
          <ModalBody>
            <input
              type="text"
              className="form-control"
              placeholder="Role Name"
              value={roleName}
              onChange={handleRoleNameChange}
            />
          </ModalBody>
          <ModalFooter>
            <button className="btn btn-secondary" onClick={toggleCreateModal}>
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSaveRole}
              disabled={!roleName.trim()}
            >
              {editRoleId ? "Update" : "Save"}
            </button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};
export default Roles;
